import { useForm } from 'react-hook-form'
import { AltaProvider } from './AltaContext'
import Steps from './Steps'
import CustomSwitch from './CustomSwitch'

function Alta() {
  const methods = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  })

  return (
    <>
      <h6 className="text-muted text-normal text-uppercase">
        Alta Contribuyente
      </h6>

      <AltaProvider>
        <Steps />
        <CustomSwitch methods={methods} />
      </AltaProvider>
    </>
  )
}

export default Alta
